"use client";

import {formatCompact, useYoutubeStats} from "@/hooks/useYoutubeStats";
import {cn} from "@/lib/utils";

export default function VideoCount({
  handle,
  channelId,
  className
}: {
  handle?: string;
  channelId?: string;
  className?: string;
}) {
  const { data, isLoading } = useYoutubeStats({ handle, channelId });
  const text = isLoading ? "2,6k" : formatCompact(data?.videoCount);

  return (
    <p className={cn(
      "leading-none mb-0 text-white/70",
      className
    )}>
      {text} Videos
    </p>
  );
}